import React from 'react'

export default () => (
    <style jsx="true">{`
.services-data {
    display: flex;
    padding: 40px 0px;
}
    `}</style>
)